import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const formatApiError = (e, fallback = "Qualcosa è andato storto. Riprova.") => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail.includes("<") ? fallback : detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const url = err?.config?.url || "";
      const status = err?.response?.status;
      if (!url.includes("/errors") && (!status || status >= 500)) {
        api.post("/errors", {
          message: String(err?.message || "network error"),
          url,
          stack: JSON.stringify(err?.response?.data || {}).slice(0, 900),
          meta: `status:${status || "network"}`,
        }).catch(() => {});
      }
    } catch { /* noop */ }
    return Promise.reject(err);
  }
);

export default api;
